import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {connectAppEnv} from '../../../app/app-env';
import {withIsOpenState, delegateOpenState, frefToRef} from '../../../lib/react/higher-order-components';
import {withUILevel} from '../../../lib/react/oe-higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import retardUpdate from '../../../lib/react/update-retarder';
import OENotification from '../../../lib/notification/oe-notification';
import {OEViewType} from '../../../lib/oe-types';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEScreenshotTool from '../../../lib/tools/oe-screenshot-tool';
import {OEManualViewLinks} from '../../views/manual-view/oe-manual-view-model';
import OEPopover from '../../views/oe-popover';
import {OEGroupControl, OEButtonControl, OEIconButtonControl, OEToggleCheckboxControl} from '../../elements/controls/oe-controls';
import {OEDefaultConfigFactory} from '../../oe-default-configs';
import {OEScreenshotControllerConfigDecl, OEScreenshotControllerConfigFactory} from './oe-screenshot-controller-model';
import OEScreenshotPreviewController from './oe-screenshot-preview-controller';

export class OEScreenshotController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            uiEnabled: false,
            uiLayer: false,
            transparency: false,
            strings:   {
                title: '',
                uiLayer: '',
                transparency: '',
                takeBtn: '',
                usageRightsLabel: ''
            },
            showPreview: false
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onHelpBtnPressed = this.onHelpBtnPressed.bind(this);
        this.onUILayerSwitchChanged = this.onUILayerSwitchChanged.bind(this);
        this.onTransparencySwitchChanged = this.onTransparencySwitchChanged.bind(this);
        this.onTakeBtnPressed = this.onTakeBtnPressed.bind(this);
        this.onUsageRightsBtnPressed = this.onUsageRightsBtnPressed.bind(this);
        this.onPreviewClosed = this.onPreviewClosed.bind(this);
        this.onPreviewToggle = this.onPreviewToggle.bind(this);
        this.onSaveBtnPressed = this.onSaveBtnPressed.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;
        this.setState({strings: {
            title: si.getLocalizedStringEnc('screenshot_view'),
            uiLayer: si.getLocalizedStringEnc('screenshot_view_ui_layer'),
            transparency: si.getLocalizedStringEnc('screenshot_view_transparency'),
            takeBtn: si.getLocalizedStringEnc('screenshot_view_take_btn'),
            usageRightsLabel: si.getLocalizedStringEnc('screenshot_view_usage_rights')
        }});
    }

    updateUIState()   {
        this.setState({ uiEnabled: this.oe.isReady() });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({ uiEnabled: false });
            return;
        }
        
        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateUIState();
        });
    }

    render() {
        if(!this.props.config.enabled) return null;
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEPopover 
                    className="popover-control screenshot-filter-hide" 
                    placement="right-start"
                    buttonClassName="transparent-btn"
                    moduleId={this.props.moduleId}
                    boundariesElement={this.props.boundariesElement}
                    target={this.props.target}
                    isOpen={this.props.isOpen}
                    title={this.state.strings.title}
                    onToggle={this.props.onToggle}
                    onHelpBtnPressed={this.props.config.showHelpBtn ? this.onHelpBtnPressed : null}
                >
                    <div className="screenshot-controller">
                        <OEGroupControl>
                            <OEToggleCheckboxControl
                                className="align-right"
                                title = {this.state.strings.uiLayer}
                                active={this.state.uiLayer}
                                disabled={!this.state.uiEnabled}
                                onClick={this.onUILayerSwitchChanged}
                            />
                            {/*
                            <OEToggleCheckboxControl
                                className="align-right"
                                title = {this.state.strings.transparency}
                                active={this.state.transparency}
                                disabled={!this.state.uiEnabled}
                                onClick={this.onTransparencySwitchChanged}
                            />
                            */}
                            <OEButtonControl disabled={!this.state.uiEnabled} onPressed={this.onTakeBtnPressed}>{this.state.strings.takeBtn}</OEButtonControl>

                            {!this.props.config.showUsageRightsBtn ? null :
                                <OEIconButtonControl
                                    className="usage-rights-btn"
                                    innerClassName="full-transparent-btn"
                                    title={this.state.strings.usageRightsLabel}
                                    icon={OEIconCodes.info}
                                    onPressed={this.onUsageRightsBtnPressed}
                                />
                            }

                        </OEGroupControl>

                        <OEScreenshotPreviewController
                            moduleId={this.props.moduleId}
                            config={this.props.config}
                            isOpen={this.state.showPreview}
                            onClosed={this.onPreviewClosed}
                            onToggle={this.onPreviewToggle}
                            image={this.state.previewImage}
                            onSaveBtnPressed={this.onSaveBtnPressed}
                        />

                    </div>

                </OEPopover>
            </React.Fragment>
        );
    }

    onHelpBtnPressed()  {
        if(this.props.appComponent)    this.props.appComponent.uiLayer.manualView.setOpen(true, {link: OEManualViewLinks.screenshot});
    }

    onUILayerSwitchChanged() {
        this.setState((prevState) => {
            let newState = clone(prevState);
            newState.uiLayer = !newState.uiLayer;
            return newState;
        });
    }

    onTransparencySwitchChanged() {
        this.setState((prevState) => {
            let newState = clone(prevState);
            newState.transparency = !newState.transparency;
            return newState;
        });
    }

    onTakeBtnPressed()  {
        this.options = {
            uiLayer: this.state.uiLayer,
            transparency: this.state.transparency
        };

        if(this.props.appComponent)    this.props.appComponent.showWaitingController();

        OEScreenshotTool.takeCanvas(this.props.moduleId, this.options).then(image => {
            this.setState({showPreview: true, previewImage: image});
            if(this.props.appComponent)    this.props.appComponent.hideWaitingController();
        });
    }

    onUsageRightsBtnPressed()   {
        if(!this.props.appComponent || !this.props.appComponent.uiLayer || !this.props.appComponent.uiLayer.startView)  return;
        this.props.appComponent.uiLayer.startView.setOpen(true, 'info-help');
    }

    onPreviewClosed()   {
        this.setState({previewImage: null});
    }

    onPreviewToggle()   {
        this.setState({showPreview: false});
    }

    onSaveBtnPressed()  {
        this.setState({showPreview: false});
    }
}

OEScreenshotController.defaultProps = {
    moduleId:               '',
    target:                 '',
    config:                 OEScreenshotControllerConfigFactory.buildStdConfig()
};

OEScreenshotController.propTypes = {
    moduleId:               PropTypes.string,
    config:                 OEScreenshotControllerConfigDecl
};

export default delegateOpenState(
    connectAppEnv((env) => {
        const ui = env.config.module.uiLayerConfig;
        return {
            appComponent:   env.component,
            appTarget:      env.config.target,
            config:         OEDefaultConfigFactory.combineShowHelpState(ui.widgetConfig.screenshotController, ui.widgetConfig.showHelp, ui.manualView.links, OEManualViewLinks.screenshot)
        }
    })(withUILevel(frefToRef(withIsOpenState(OEScreenshotController, (sender, isOpen) => {
        let appComponent = sender.props.appComponent;
        if(!appComponent || !appComponent.uiLayer) return;

        appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type:           OEViewType.screenshot,
            isOpen:         isOpen,
            sender:         sender
        });
    }))))
);